import React from 'react';
import './Hotselling.css';

import img800 from '../../../imgs/8ton.webp';
import img1000 from '../../../imgs/10ton.webp';
import img1500 from '../../../imgs/15ton.webp';
import img2000 from '../../../imgs/20ton.webp';
import img2500 from '../../../imgs/25ton.webp';
import img3000 from '../../../imgs/30ton.webp';

const machines = [
  { title: '800 Ton Injection Molding Machine', img: img800 },
  { title: '1000 Ton Injection Molding Machine', img: img1000 },
  { title: '1500 Ton Injection Molding Machine', img: img1500 },
  { title: '2000 Ton Injection Molding Machine', img: img2000 },
  { title: '2500 Ton Injection Molding Machine', img: img2500 },
  { title: '3000 Ton Injection Molding Machine', img: img3000 },
];

const Hotselling = () => {
  return (
    <section className="hotselling-wrapper">
      <h2 className="hotselling-heading">Hot-Selling Two Platen Series</h2>

      <div className="card-grid" data-aos="fade-down">
        {machines.map(({ title, img }) => (
          <div className="machine-card" key={title}>
            <img src={img} alt={title} className="machine-img" />
            <h3 className="machine-title">{title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Hotselling;
